export const getObject = (obj) => {
    const value = Object.keys(obj)[0]

    return obj[value]
}